import { StatsGranularity } from "components/src/stats/constants";

const VERSION = 'v1';
const DB_PROFILES_FOLDER = 'users';
const DB_STATS_FOLDER = 'stats';
const DB_READING_STATS_FOLDER = 'reading_stats';

export const paths = {
  database: {
    userCheckouts: (uid: string) => `${VERSION}/${DB_PROFILES_FOLDER}/${uid}/checkouts`,
    userProfile: (uid: string) => `${VERSION}/${DB_PROFILES_FOLDER}/${uid}/profile`,
    userReadingStats: (uid: string, granularity: StatsGranularity) =>
      `${VERSION}/${DB_STATS_FOLDER}/${uid}/${DB_READING_STATS_FOLDER}/${granularity}`,
  },
};



// WEBPACK FOOTER //
// ./src/paths.ts